export default __webpack_public_path__ + "static/InterDisplay-Light-f902f68d3cab65cc272bbe6a3412e62e.woff";